import { EventEmitter } from '../EventEmitter';
export var HistoryEvents;
(function (HistoryEvents) {
    HistoryEvents["historyChanged"] = "historyChanged";
})(HistoryEvents || (HistoryEvents = {}));
export class HistoryManager extends EventEmitter {
    constructor() {
        super(...arguments);
        this.undos = [];
        this.redos = [];
        this.lastCmdTime = new Date();
        this.idCounter = 0;
        this.historyDisabled = false;
        this.timeThreshold = 500;
    }
    execute(cmd, optionalName) {
        const lastCmd = this.undos[this.undos.length - 1];
        const timeDifference = new Date().getTime() - this.lastCmdTime.getTime();
        const isUpdatableCmd = lastCmd && lastCmd.updatable && cmd.updatable && cmd.isCompatibleWith(lastCmd);
        if (isUpdatableCmd && timeDifference < this.timeThreshold) {
            lastCmd.update(cmd);
            cmd = lastCmd;
        }
        else {
            // the command is not updatable and is added as a new part of the history
            this.undos.push(cmd);
            cmd.id = ++this.idCounter;
        }
        cmd.name = optionalName !== undefined ? optionalName : cmd.name;
        cmd.execute();
        cmd.inMemory = true;
        cmd.json = cmd.toJSON();
        this.lastCmdTime = new Date();
        this.redos = [];
        this.emit(HistoryEvents.historyChanged, cmd);
    }
    undo() {
        if (this.historyDisabled) {
            console.error('Undo/Redo is disabled.');
            return null;
        }
        let cmd = null;
        if (this.undos.length > 0) {
            const poppedItem = this.undos.pop();
            if (poppedItem !== undefined) {
                cmd = poppedItem;
            }
            if ((cmd === null || cmd === void 0 ? void 0 : cmd.inMemory) === false && cmd.json) {
                cmd.fromJSON(cmd.json);
            }
        }
        if (cmd !== null) {
            cmd.undo();
            this.redos.push(cmd);
            this.emit(HistoryEvents.historyChanged, cmd);
        }
        return cmd;
    }
    redo() {
        if (this.historyDisabled) {
            console.error('Undo/Redo is disabled.');
            return null;
        }
        let cmd = null;
        if (this.redos.length > 0) {
            const poppedItem = this.redos.pop();
            if (poppedItem !== undefined) {
                cmd = poppedItem;
            }
            if ((cmd === null || cmd === void 0 ? void 0 : cmd.inMemory) === false && cmd.json) {
                cmd.fromJSON(cmd.json);
            }
        }
        if (cmd !== null) {
            cmd.execute();
            this.undos.push(cmd);
            this.emit(HistoryEvents.historyChanged, cmd);
        }
        return cmd;
    }
    clear() {
        this.undos = [];
        this.redos = [];
        this.idCounter = 0;
        this.emit(HistoryEvents.historyChanged, null);
    }
    getUndos() {
        return this.undos;
    }
    getRedos() {
        return this.redos;
    }
}
